import { useSyncExternalStore } from "react"

/** The article text's sizes in px; `size` is an index into these. */
export const READER_SIZES = [16, 17, 18, 20, 22]

type Reader = { sans: boolean; size: number; wide: boolean }

const KEY = "nook:reader"
const listeners = new Set<() => void>()

/** The reader's Aa, after Instapaper: face, size and an expanded panel. A preference of this browser, like the library view. */
export function useReader() {
  const raw = useSyncExternalStore(
    (listener) => (listeners.add(listener), () => listeners.delete(listener)),
    () => localStorage.getItem(KEY),
  )
  const reader: Reader = { sans: false, size: 2, wide: false, ...(raw && JSON.parse(raw)) }

  return [
    reader,
    (next: Partial<Reader>) => {
      localStorage.setItem(KEY, JSON.stringify({ ...reader, ...next }))
      listeners.forEach((listener) => listener())
    },
  ] as const
}
